import React from 'react'

export interface StepItemProps {
  imgSrc: any
  imgAltText: string
  prominentText: string
  prominentTextColor: string
  descriptionText: string
  descriptionTextColor: string
  isMobile?: boolean
}

const StepItem = ({
  imgSrc,
  imgAltText = '',
  prominentText,
  prominentTextColor,
  descriptionText,
  descriptionTextColor,
  isMobile
}: StepItemProps) => {
  return (
    <div className="z-index-2 relative my-4 flex w-full gap-x-2 bg-transparent sm:flex-row">
      <div className="step-img-wrapper w-1/4 max-w-[10rem] sm:w-full sm:px-8">
        <img src={imgSrc} alt={imgAltText} className="w-full" />
      </div>
      <div className="text-wrapper flex w-3/4 flex-col justify-center sm:w-full">
        <div className="prominent-text">
          <h3 className="font-third my-1 text-4xl text-black sm:text-5xl" style={{ color: prominentTextColor }}>
            {prominentText}
          </h3>
        </div>
        <div className="description-text">
          <p className="my-1 text-sm" style={{ color: descriptionTextColor }}>
            {descriptionText}
          </p>
        </div>
      </div>
    </div>
  )
}

export default StepItem

export const StepItemRegisterProps = {
  name: 'stepItem',
  type: 'object',
  defaultValue: {
    imgSrc: null,
    imgAltText: '',
    prominentText: 'We source food from our trusted network of farmers',
    prominentTextColor: '#000000',
    descriptionText: 'We source and make delicious food for your dog using the finest ingredients',
    descriptionTextColor: '#000000'
  },
  subFields: [
    { name: 'imgSrc', type: 'file', defaultValue: null },
    { name: 'imgAltText', type: 'string', defaultValue: '' },
    { name: 'prominentText', type: 'string', defaultValue: 'We source food from our trusted network of farmers' },
    { name: 'prominentTextColor', type: 'color', defaultValue: '#000000' },
    {
      name: 'descriptionText',
      type: 'text',
      defaultValue: 'We source and make delicious food for your dog using the finest ingredients'
    },
    { name: 'descriptionTextColor', type: 'color', defaultValue: '#000000' }
  ]
}
